const current = [
  {
    path: '/notice/current/detail/:id',
    name: '상세페이지',
    component: () => import('@/page/notice/current/Detail.vue'),
    meta: {
      name: '상세페이지',
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/notice/current/revise/:id',
    name: '상세페이지 수정',
    component: () => import('@/page/notice/current/Revise.vue'),
    meta: {
      name: '상세페이지 수정',
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/notice/current/register',
    component: () => import('@/page/notice/Register.vue'),
    meta: {
      name: '공지사항 추가',
      isActive: false,
      isBread: true,
    },
  },
];

export default current;
